<template>
  <div>
    <a-card>
      <div slot="header" class="module-header">
        <div v-t="'Config.UserProfile.ProfilePreferences.ProfileImage'" />
      </div>
      <div slot="body" class="module-body">
        <div class="row justify-space-between">
          <div class="col">
            <img
              class="mb-2"
              :src="userImageSrc"
              width="80"
              :heigth="80 * pictureRatio"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <a-checkbox
              v-model="secretFlag"
              :label="$t('Config.UserProfile.ProfilePreferences.secreteImage')"
            />
          </div>
        </div>
      </div>
      <template slot="footer">
        <button
          v-t="'Config.UserProfile.ProfilePreferences.DeleteImage'"
          type="button"
          class="btn btn-pf-secondary"
          @click="showResetImageConfirmDialog = true"
        />
        <button
          v-t="'Config.UserProfile.ProfilePreferences.ChangeImage'"
          type="button"
          class="btn btn-pf-secondary"
          @click="showImageDialog = true"
        />
        <button
          v-t="'Config.UserProfile.ProfilePreferences.SaveProfileImageSettings'"
          type="button"
          class="btn btn-pf-primary ml-2"
          @click="saveProfileImageSettings"
        />
      </template>
    </a-card>
    <a-image-dialog v-model="showImageDialog" :image-url="userImageSrc" />
    <reset-image-dialog
      v-model="showResetImageConfirmDialog"
      @reset-user-image="resetUserImage"
    />
  </div>
</template>

<script>
import Card from "+/components/card/Card";
import ResetImageConfirmDialog from "./reset-image-confirm-dialog";
import ImageDialog from "./image-dialog";
import { mapActions, mapGetters } from "vuex";
import ACheckbox from "+/components/form/checkbox/Checkbox";

export default {
  components: {
    "reset-image-dialog": ResetImageConfirmDialog,
    "a-image-dialog": ImageDialog,
    "a-card": Card,
    "a-checkbox": ACheckbox
  },
  props: {
    pictureRatio: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    showResetImageConfirmDialog: false,
    showImageDialog: false,
    secretFlag: false
  }),
  computed: {
    ...mapGetters("userProfile", ["userImageSrc"])
  },
  created() {
    this.getSecretFlag(data => {
      this.secretFlag = data == "1";
    });
  },
  methods: {
    ...mapActions("userProfile", ["setUserImgSrc", "deleteUserImg"]),
    resetUserImage() {
      this.showResetImageConfirmDialog = false;
      this.deleteUserImage();
    },
    deleteUserImage() {
      this.$rest.config.deleteUserImage().then(() => {
        const deleteImageSuccess = this.$t(
          "Config.UserProfile.ProfilePreferences.DeleteImageSuccess"
        );
        this.$feedback(deleteImageSuccess, {
          type: "success"
        });
        this.deleteUserImg();
      });
    },
    getSecretFlag(callback) {
      this.$rest.config
        .getSecretFlag()
        .then(response => callback(response.data))
        .catch(error => window.atomlog(`getSecretFlag: ${error}`, "error"));
    },
    saveProfileImageSettings() {
      let secretFlag = this.secretFlag == true ? "1" : "0";
      this.$rest.config
        .setSecretFlag({ "secret-flag": secretFlag })
        .then(this.saveSuccess)
        .catch(this.saveError);
    },
    saveSuccess() {
      const successTranslation = this.$t(
        "Config.UserProfile.ProfilePreferences.ImageConfigSaveSuccess"
      );
      this.$feedback(successTranslation, {
        type: "success"
      });
      this.navigateToUserProfile();
    },
    saveError(error) {
      const errorTranslation = this.$t(
        "Config.UserProfile.ProfilePreferences.ImageConfigSaveError"
      );
      this.$feedback(errorTranslation, {
        type: "error"
      });
      window.atomlog(error, "error");
    },
    navigateToUserProfile() {
      this.$router.push({ name: "config.userprofile" });
    }
  }
};
</script>
